import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Check, Clock, FileText, User } from 'lucide-react';

export const StatsCards = ({ pendingCount, approvedCount, avgQuoteValue, pendingHandymenCount }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6">
      <Card className="bg-yellow-50 border-yellow-200">
        <CardContent className="p-3 md:p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-yellow-600 font-medium">Pending Quotes</p>
              <p className="text-2xl md:text-3xl font-bold text-yellow-700">{pendingCount}</p>
            </div>
            <Clock className="w-8 h-8 text-yellow-400" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-green-50 border-green-200">
        <CardContent className="p-3 md:p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-green-600 font-medium">Approved</p>
              <p className="text-2xl md:text-3xl font-bold text-green-700">{approvedCount}</p>
            </div>
            <Check className="w-8 h-8 text-green-400" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="p-3 md:p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-blue-600 font-medium">Avg Quote</p>
              <p className="text-2xl md:text-3xl font-bold text-blue-700">{avgQuoteValue}</p>
            </div>
            <FileText className="w-8 h-8 text-blue-400" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-purple-50 border-purple-200">
        <CardContent className="p-3 md:p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-purple-600 font-medium">Handyman Apps</p>
              <p className="text-2xl md:text-3xl font-bold text-purple-700">{pendingHandymenCount}</p>
            </div>
            <User className="w-8 h-8 text-purple-400" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
